exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_ab1e15f{width:250px!important;display:inline-block!important}.wrapper_1c75666{position:relative;display:inline-block}.wrapper_1c75666>.tip_1f190b0{position:absolute;width:320px;height:80px;left:27px;z-index:10000;top:-10px;padding:10px 15px;line-height:20px;background-color:#5b5858;color:#fff;border-radius:10px;display:none}.wrapper_1c75666:hover{cursor:pointer}.wrapper_1c75666:hover .tip_1f190b0{display:block}.desc_b458992{color:#999}.pic_desc_0f0ee75{color:rgba(255,102,0,.423)}.query_d09cd11{display:inline-block;overflow:hidden;margin-right:13px}.query_d09cd11>p{float:left}.query_d09cd11>.switch_aff1fa2{width:35px;float:left}.query_d09cd11:last-child{margin-right:0}.textarea_921f8b4{width:420px!important;height:200px}.textarea_921f8b4 .k-textarea{height:200px!important;resize:none}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_ab1e15f",
	"wrapper": "wrapper_1c75666",
	"tip": "tip_1f190b0",
	"desc": "desc_b458992",
	"pic_desc": "pic_desc_0f0ee75",
	"query": "query_d09cd11",
	"switch": "switch_aff1fa2",
	"textarea": "textarea_921f8b4"
};